export default "__VITE_ASSET__DgID_aB3__"